
export type RegisterCard200 = {
  billingKey?: string;
  cardName?: string;
  message?: string;
  success: boolean;
};
